import { makeObservable } from "mobx"
import { IAuthStore, Store, IDashboardStore, IAccountStore, ISettingsStore, IAlarmStore, IMotiTagStore, ILeagueStore, IUserFeedbackStore, IReportStore } from "../global/types"
import AuthStore from "./AuthStore"
import DashboardStore from "./DashboardStore"
import AccountStore from './AccountStore'
import SettingsStore from "./SettingsStore"
import AlarmStore from "./AlarmStore"
import MotiTagStore from "./MotiTagStore"
import LeagueStore from "./LeagueStore"
import UserFeedbackStore from "./UserFeedbackStore"
import ReportStore from "./ReportStore"
class RootStore implements Store {
    public authStore: IAuthStore
    public dashboardStore: IDashboardStore
    public accountStore: IAccountStore
    public settingsStore: ISettingsStore
    public alarmStore: IAlarmStore
    public motiTagStore: IMotiTagStore
    public leagueStore: ILeagueStore
    public userFeedbackStore: IUserFeedbackStore
    public reportStore: IReportStore

    constructor() {
        makeObservable(this);
        this.authStore = new AuthStore(this)
        this.dashboardStore = new DashboardStore(this)
        this.accountStore = new AccountStore(this)
        this.settingsStore = new SettingsStore(this)
        this.alarmStore = new AlarmStore(this)
        this.motiTagStore = new MotiTagStore(this)
        this.leagueStore = new LeagueStore(this)
        this.userFeedbackStore = new UserFeedbackStore(this)
        this.reportStore = new ReportStore(this)
    }
}

export default RootStore;
